import { OccupantDetailExtended } from '@centecomm/portal-service';
import { LoadStatus } from 'Types';
import { Occupant } from '../Types';

const mapOccupantResponseToBusinessOccupant = ({
    id,
    marketingName,
    spaces,
    phone,
    leaseStart,
    leaseEnd,
    collectSalesStartDate,
    propertyId,
    propertyName,
    salesSubmissionFrequency,
    mailingAddress,
    physicalAddress,
    company,
}: OccupantDetailExtended): Occupant => ({
    id,
    marketingName,
    propertyId,
    propertyName,
    salesSubmissionFrequency,
    spaces,
    phone,
    collectSalesStartDate,
    leaseEnd,
    leaseStart,
    mailingAddress,
    physicalAddress,
    loadStatus: LoadStatus.LOADED,
    companyName: company.name,
    companyId: company.id,
});

export default mapOccupantResponseToBusinessOccupant;
